import React from 'react';
import styles from 'feature/license-plates/index.module.scss';
import PageLayout from 'layout/page';
import Button from 'components/button';
import PlateNumberForm from 'module/plate-number-form';
import { isNpcpay } from 'config';
import RentalPlateDialog from 'components/rental-plate-dialog';
import amplitude from 'service/amplitude';

const EditLicensePlateLayout = ({
  plateNumber = '',
  vehicleType = '',
  energySource = '', 
  onEnergySourceChange,
  onTextChanged,
  errorMessage,
  onRadioClick,
  onClick,
  onFocus,
  btnLoading,
  type = 'new',
  rentalPlateDialogShow,
  rentalPlateDialogOnClick,
}) => {
  return (
    <PageLayout theme="form">
      <RentalPlateDialog
        show={rentalPlateDialogShow}
        onShow={() => amplitude.plateNumber_rental_dialog_pageview()}
        onClick={() => {
          amplitude.plateNumber_rental_dialog_confirm_onClick();
          rentalPlateDialogOnClick();
        }}
      />
      <div className={styles['edit-license-plate-layout']}>
        <div className={styles['layout-body']}>
          <PlateNumberForm
            title={type === 'edit' ? '修改付款車牌' : '加入付款車牌'}
            plateNumber={plateNumber}
            plateNumberErrorMessage={errorMessage}
            onPlateNumberChange={onTextChanged}
            carType={vehicleType}
            onCarTypeChanged={onRadioClick}
            onPlateNumberFocus={onFocus}
            energySource={energySource}
            onEnergySourceChange={onEnergySourceChange}
          />
        </div>
        <div>
          <Button theme="submit-btn" onClick={onClick} loading={btnLoading} disabled={btnLoading}>
            設定好了
          </Button>
          {isNpcpay && <div className={styles['npc-hint']}>「台北市公有停車場」隔日才能使用自動扣款出場</div>}
        </div>
      </div>
    </PageLayout>
  );
};

export default EditLicensePlateLayout;
